/* ============================================================
   sm-vs-herbergi.js - Herbergisn\u00famer and H\u00f3telskilti on the one page kit (adapter 'herbergi';
   sections/sm-vel.liquid, assets/sm-vel-sida.js, snippets/sm-vl-herbergi.liquid).
   herbergi-skipting (2026-10-01): the old seven step page split in two simple pages on the same
   engine, assets/sm-herbergi-vel.js (window.SMHerb 1.3.0).

   adapter_stillingar.snid picks the page:
     'numer' (default, product herbergisnumer): N\u00famer -> Texti undir (Ekkert / HERBERGI / ROOM /
       HERBERGI \u00b7 ROOM, always a small engraved line) -> Efni og litur -> Bak (acrylic) -> St\u00e6r\u00f0 ->
       Rammi (two-tone) -> Festing -> Fj\u00f6ldi. The number is cut through on hnota / akr\u00fdl / \u00e1n baks
       (bridged digits) and engraved on two-tone. Rounded Elegance Open, capitals.
     'hotel' (product hotelskilti): Skilti (every tile its own finished design: 9 ready signs plus
       Eigin texti) -> Texti (\u00cdslenska / Enska / B\u00e6\u00f0i, and Bara t\u00e1kn on the icon signs; own text gets
       a field and an optional second line) -> Efni og litur -> Bak -> St\u00e6r\u00f0 -> Rammi -> Festing ->
       Fj\u00f6ldi. Words and icons are ALWAYS engraved, icon above the text.

   Rules of both: a step only shows what is producible given the earlier choices (sizes the text
   fits on, standoffs only where the size has them); a change higher up moves a later choice that
   became impossible to the nearest valid one, quietly. Tiles show their own design.
   The adapter picks the variant (Ger\u00f0, St\u00e6r\u00f0, Festing are Shopify options); plate, backing and
   two-tone colours and the frame are properties.

   Strings: every text a customer sees comes from the page data (ctx.vel.ord, rendered from
   snippets/sm-herbergi-ord.liquid by snippets/sm-vl-herbergi.liquid). Cart keys are fixed
   Icelandic data as before. ES5, ASCII only on disk (built by src/byggja.sh).
   ============================================================ */
(function () {
  'use strict';
  function H() { return window.SMHerb; }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function trim(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function thus(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function kr(aurar) { var n = Math.round((Number(aurar) || 0) / 100); return (n < 0 ? '-' : '') + thus(Math.abs(n)) + ' kr.'; }
  function munurKr(aurar) { return (aurar > 0 ? '+' : '-') + thus(Math.round(Math.abs(aurar) / 100)) + ' kr.'; }
  function mm1(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function afrit(o) { var r = {}, k; for (k in o) if (has(o, k)) r[k] = o[k]; return r; }

  /* fixed cart keys and values (Icelandic data, as before) */
  var EIG = { numer: 'N\u00famer', texti: 'Texti', undir: 'Texti undir', plata: 'Plata', bak: 'Bak', litur: 'Litur', rammi: 'Rammi', aths: 'Athugasemdir me\u00f0 p\u00f6ntun', takn: 'T\u00e1kn', letur: 'Letur' };
  var SYNI_NUMER = '204', SYNI_EIGIN = 'Texti';
  var HLUTVERK = ['gerd', 'staerd', 'festing'];
  var AKRYL_K = ['svart-matt', 'svart-glans', 'hvitt-matt', 'hvitt-glans'], TVILITT_K = ['gull', 'silfur', 'svart', 'hvitt'];
  var UNDIR_K = ['ekkert', 'herbergi', 'room', 'baedi'], MAL_K = ['is', 'en', 'baedi', 'ekkert'];
  /* 14.10 (owner): room numbers get a Letur step, both fonts always offered (never hide an option). reo = the font the room
     numbers have always had (default, the production file is byte for byte the same), didot = SM Didot (bridged when cut).
     The names come from adapter_stillingar.letur_heiti; the cart gets the name (Letur) and the font id (_letur). */
  var LETUR_K = ['reo', 'didot'], LETUR_HEITI = { reo: 'N\u00fat\u00edmalegt', didot: 'Klass\u00edskt' };
  var LETUR_ID = { reo: 'rounded-elegance-open', didot: 'smdidot-400' }, DIDOT_IDS = ['smdidot-400', 'smdidot-400-bryr'];
  /* FK 21.10: the font style name as SHOWN outside Icelandic (ord letur_syn_<k>); the cart (Letur) keeps the Icelandic name */
  function leturSyn(ctx, k) { return t(ctx, 'letur_syn_' + k) || leturHeiti(ctx, k); }
  function leturHeiti(ctx, k) { var h = P(ctx).LETUR_HEITI || {}; return h[k] || LETUR_HEITI[k] || k; }
  function erDidot(ctx, s) { return !hotel(ctx) && !!s && s.letur === 'didot'; }
  /* the readability rule of the hotel page (owner 2026-10-01): a size is offered only when the main word sits on one
     line at a comfortable engraved cap height: at least HOTEL_MIN mm and a share of the shorter plate side (an icon
     above the word takes its own room, the small 9 x 9 square asks a little more); the English line under at least
     HOTEL_MIN2 mm */
  var HOTEL_MIN = 7.5, HOTEL_MIN2 = 4, HOTEL_UNDIR = 0.34;
  /* owner 14.10 (the text shouted): the main text is at most TEXTI_B of the plate width and its capital height at most TEXTI_H of the
     plate height (engine options hamarkB / hamarkH, same engine for hotel signs and room numbers). A design that is at this
     limit counts as readable even under the HOTEL_MIN share rule below: the limit, not the share, then sets its size. */
  var TEXTI_B = 0.62, TEXTI_H = 0.28;
  function hotelHlutfall(S, takn) { var litid = S.b === S.h && S.h <= 90; return takn ? (litid ? 0.10 : 0.085) : (litid ? 0.12 : 0.09); }
  var FIT_STOPP = { of_langt: 1, of_smatt: 1, undir_langt: 1, eyja: 1, takn_litid: 1, takn_of_langt: 1, takn_9x9: 1, undir_smatt: 1, takn_skorid: 1 };
  var FULLT_BID = 260;
  var TAKN_RE;
  try { TAKN_RE = new RegExp('[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\u20E3\\uFE0E\\uFE0F\\u200D]', 'gu'); }
  catch (e) { TAKN_RE = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27bf]|\ufe0f|\u200d/g; }

  /* ---------------- one page state (ctx.hb) ---------------- */
  function P(ctx) { return ctx.hb; }
  function hotel(ctx) { return P(ctx).snid === 'hotel'; }
  function t(ctx, k, v) {
    var o = (ctx.vel && ctx.vel.ord) || {}, s = o[k] != null ? String(o[k]) : '';
    if (v) s = s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? String(v[n]) : m; });
    return s;
  }

  /* options by role: Ger\u00f0, St\u00e6r\u00f0, Festing, value codes by position (adapter_stillingar.kodar) */
  function lesaKoda(ctx) {
    var p = P(ctx), vara = ctx.vara(), K = (ctx.stillingar && ctx.stillingar.kodar) || {}, ok = true;
    var villa = function (s) { ok = false; if (window.console) console.warn('sm-vs-herbergi: ' + s + ' S\u00ed\u00f0an selur ekki fyrr en \u00fea\u00f0 er laga\u00f0.'); };
    p.KODAR = {}; p.IX = {};
    if (!H()) villa('v\u00e9lin sm-herbergi-vel.js hl\u00f3\u00f0st ekki.');
    var val = vara.valkostir || [];
    if (val.length !== 3) villa('varan \u00fearf valkost fyrir ger\u00f0, st\u00e6r\u00f0 og festingu (' + val.length + ').');
    HLUTVERK.forEach(function (h, i) {
      var k = String(K[h] || '').split(',').map(trim).filter(Boolean), o = val[i], sed = {};
      p.KODAR[h] = k; p.IX[h] = i;
      var tafla = h === 'gerd' ? 'GERDIR' : h === 'staerd' ? 'STAERDIR' : 'FESTING';
      var gott = !!o && o.gildi.length === k.length && k.every(function (x) { var nytt = !sed[x]; sed[x] = 1; return nytt && !!H() && has(H()[tafla], x); });
      if (!gott) villa('k\u00f3\u00f0ar fyrir \'' + h + '\' passa ekki vi\u00f0 v\u00f6runa.');
    });
    p.KODAR_OK = ok;
  }
  function nafnAf(ctx, h, kodi) { var p = P(ctx), i = (p.KODAR[h] || []).indexOf(kodi), o = (ctx.vara().valkostir || [])[p.IX[h]]; return i < 0 || !o || !o.gildi[i] ? null : o.gildi[i].nafn; }
  function kodiAf(ctx, h, nafn) { var p = P(ctx), o = (ctx.vara().valkostir || [])[p.IX[h]]; if (!o) return null; for (var i = 0; i < o.gildi.length; i++) if (o.gildi[i].nafn === nafn) return (p.KODAR[h] || [])[i] || null; return null; }
  function finna(ctx, k) {
    var p = P(ctx);
    if (!p.KODAR_OK) return null;
    var vv = ctx.vara().afbrigdi || [], i, h;
    for (i = 0; i < vv.length; i++) {
      var ok = true;
      for (h = 0; h < HLUTVERK.length; h++) { var nm = nafnAf(ctx, HLUTVERK[h], k[HLUTVERK[h]]); if (nm == null || vv[i].n[p.IX[HLUTVERK[h]]] !== nm) { ok = false; break; } }
      if (ok) return vv[i];
    }
    return null;
  }
  function val(ctx, o) { var p = P(ctx), k = { gerd: p.gerd, staerd: p.staerd, festing: p.festing }, x; for (x in o) if (has(o, x)) k[x] = o[x]; return k; }
  function munur(ctx, a, b) { var va = finna(ctx, val(ctx, a)), vb = finna(ctx, val(ctx, b)); return va && vb ? vb.verd - va.verd : 0; }
  function tappar(sz) { var S = H() && H().STAERDIR[sz]; return S ? S.tappar : 0; }
  /* the festing a size can have: the customer's, or glue where the size has no standoffs */
  function festingA(ctx, sz, f) { return tappar(sz) === 0 ? 'lim' : f; }

  /* ---------------- presets (hotel) ---------------- */
  function snid(ctx, k) { return P(ctx).TEGUNDIR[k] || null; }
  function erEigin(ctx, s) { return !hotel(ctx) || s.skilti === 'eigin' || !snid(ctx, s.skilti); }
  /* the icon of a ready sign on the current material: on cut materials only an icon the engine can cut (built-in bridges
     >= 1,3 mm, webs >= 3 mm, measured in herbergi-takn round 2: CF 001, PF 001, TF 014); two-tone engraves every icon */
  function snidTakn(ctx, k, gerd) { var T = snid(ctx, k), p = P(ctx), I = T && T.takn && p.taknKlar ? p.TKM[T.takn] : null; return I && (!skoridGerd(gerd || p.gerd) || I.sk) ? T.takn : ''; }
  /* the language choices a ready sign offers: Bara t\u00e1kn only where there is an icon on this material */
  function malKostir(ctx, k, gerd) { return snidTakn(ctx, k, gerd) ? MAL_K : MAL_K.slice(0, 3); }
  function malGilt(ctx, k, mal, gerd) { return malKostir(ctx, k, gerd).indexOf(mal) >= 0; }
  /* the lines under that are producible on at least one size with this material (room numbers) */
  function undirIBodi(ctx, st) {
    var p = P(ctx);
    if (!p.leturKlar) return UNDIR_K.slice();
    return UNDIR_K.filter(function (u) { if (u === 'ekkert') return true; var s2 = afrit(st); s2.undirVal = u; return staerdirIBodi(ctx, s2).length > 0; });
  }
  function undirTexti(ctx, k) {
    return { ekkert: '', herbergi: t(ctx, 'undir.herbergi'), room: t(ctx, 'undir.room'), baedi: t(ctx, 'undir.baedi') }[k] || '';
  }
  function rammiAf(s, ctx, gerd) {
    if (gerd !== 'tvilitt') return false;
    var r = s && s.rammi;
    if (r === 'med' || r === 'an') return r === 'med';
    return P(ctx).rammiSidast !== 'an';
  }
  function skoridGerd(g) { return !!(H() && H().GERDIR[g] && H().GERDIR[g].skorid); }
  function erDokkt(k) { return k === 'svart-matt' || k === 'svart-glans'; }
  function taknHeiti(ctx, k) { var T = P(ctx).TKM[k]; return T ? T.heiti : ''; }

  /* ---------------- the engine: layout with a cache ---------------- */
  /* the lines of a state: main text, text under, icon, and whether the main text is the sample */
  function linur(ctx, s) {
    var p = P(ctx), r = { texti: '', undir: '', takn: '', syni: false };
    if (!hotel(ctx)) {
      r.texti = trim(s.texti); if (!r.texti) { r.texti = SYNI_NUMER; r.syni = true; }
      r.undir = undirTexti(ctx, s.undirVal);
      return r;
    }
    if (erEigin(ctx, s)) {
      r.texti = trim(s.texti); if (!r.texti) { r.texti = SYNI_EIGIN; r.syni = true; }
      r.undir = s.undirA ? trim(s.undir) : '';
      return r;
    }
    var T = snid(ctx, s.skilti), mal = malGilt(ctx, s.skilti, s.mal, s.gerd) ? s.mal : 'is';
    r.takn = snidTakn(ctx, s.skilti, s.gerd);
    if (mal === 'is' || mal === 'baedi') r.texti = T.heiti; else if (mal === 'en') r.texti = T.enska || T.heiti;
    if (mal === 'baedi') r.undir = T.enska || '';
    if (mal === 'ekkert' && !r.takn) r.texti = T.heiti;
    return r;
  }
  function vantarTexta(ctx, s) { return linur(ctx, s).syni; }
  function vels(ctx, s, o) {
    o = o || {};
    var L = linur(ctx, s), e = {
      gerd: o.gerd || s.gerd, staerd: o.staerd || s.staerd, festing: o.festing || s.festing, plata: s.plata, bak: s.bak, litur: s.litur, letur: erDidot(ctx, s) ? 'didot' : 'reo', rammi: s.rammi,
      texti: o.texti != null ? o.texti : L.texti, undir: o.undir != null ? o.undir : L.undir,
      hamarkB: o.otakmarkad ? 0 : TEXTI_B, hamarkH: o.otakmarkad ? 0 : TEXTI_H
    };
    /* hotel signs (owner 01.10): cut on hnota / one-colour acrylic like the numbers, engraved on two-tone */
    if (hotel(ctx)) { e.undirHlutfall = HOTEL_UNDIR; e.vara = 'hotelskilti'; e.heiti = 'H\u00f3telskilti'; if (L.takn) { e.takn = L.takn; e.taknStada = 'ofan'; } }
    /* owner 01.10: an engraved line barely shows on one-colour acrylic, so on cut materials the line under is CUT like the
       number (the engine's cut sub text path, min 10 mm, bridges and webs measured); two-tone keeps it engraved */
    return e;
  }
  function uppsetning(ctx, s, o) {
    var p = P(ctx);
    if (!H() || !p.leturKlar) return null;
    var e = vels(ctx, s, o);
    if (e.letur === 'didot' && !p.didotKlar) return null;   /* SM Didot still loading: nothing drawn, nothing cached */
    var k = JSON.stringify(e) + (o && o.anAthugunar ? '|a' : '');
    if (has(p.skyndi, k)) return p.skyndi[k];
    var U = null;
    try { U = H().uppsetning(e, o && o.anAthugunar ? { anAthugunar: true } : null); } catch (x) { if (window.console) console.warn('sm-vs-herbergi: ' + (x && x.message)); U = null; }
    if (U && !U.ok && e.hamarkB && !(o && o.otakmarkad)) {
      var o2 = {}, y; for (y in o) if (has(o, y)) o2[y] = o[y];
      o2.otakmarkad = true;
      var Uo = uppsetning(ctx, s, o2);
      if (Uo && Uo.ok) U = Uo;
    }
    p.skyndi[k] = U; p.skyndiRod.push(k);
    if (p.skyndiRod.length > 160) delete p.skyndi[p.skyndiRod.shift()];
    return U;
  }
  /* the kit's own values when a hook has no state at hand (frame step) */
  function nuS(ctx) { return { rammi: ctx.rammiGildi() }; }
  /* the full adapter state: the customer's choices (ctx.hb) plus the kit's frame step */
  function stadaAf(ctx, s) {
    var p = P(ctx), r = afrit(p);
    r.rammi = rammiAf(s, ctx, r.gerd);
    return r;
  }
  function cap(U, l) { return U && U[l] ? U[l].mm * H()._innri.F[U[l].id].cap : 0; }
  /* does the design fit this size? room numbers: the engine's own checks (cut digits measured); hotel signs: the
     engine (engraved, every size holds something) plus the readability rule */
  function passarMed(ctx, s2, sz) {
    var U = uppsetning(ctx, s2);
    if (!U || !U.g || (U.villur || []).some(function (v) { return FIT_STOPP[v.kodi] || v.kodi === 'festing'; })) return false;
    if (!U.ok) return false;
    if (!hotel(ctx)) return true;
    var S = H().STAERDIR[sz], L = linur(ctx, s2), Uo = uppsetning(ctx, s2, { otakmarkad: true });
    if (!Uo || !Uo.ok) return false;
    var c1 = cap(Uo, 'l1'), c2 = cap(Uo, 'l2');
    return (!L.texti || (c1 >= HOTEL_MIN - 1e-6 && c1 >= hotelHlutfall(S, !!L.takn) * Math.min(S.b, S.h) - 1e-6)) && (!L.undir || c2 >= HOTEL_MIN2 - 1e-6);
  }
  /* a size is offered only when the design fits it with glue AND with standoffs (their holes take room), so the
     Festing step after it never has to move the size */
  function passar(ctx, st, sz) {
    var p = P(ctx), s2 = afrit(st); s2.staerd = sz; s2.festing = 'lim';
    var k = JSON.stringify(vels(ctx, s2));
    if (has(p.passarSk, k)) return p.passarSk[k];
    var ok = passarMed(ctx, s2, sz);
    if (ok && tappar(sz) > 0) { var s3 = afrit(s2); s3.festing = 'silfur'; ok = passarMed(ctx, s3, sz); }
    p.passarSk[k] = ok; p.passarRod.push(k);
    if (p.passarRod.length > 400) delete p.passarSk[p.passarRod.shift()];
    return ok;
  }
  /* the sizes this design is offered on, in the product's order; [] when the text fits nowhere */
  function staerdirIBodi(ctx, st) {
    var p = P(ctx);
    if (!p.leturKlar) return (p.KODAR.staerd || []).slice();
    return (p.KODAR.staerd || []).filter(function (sz) { return finna(ctx, val(ctx, { staerd: sz, festing: festingA(ctx, sz, st.festing) })) && passar(ctx, st, sz); });
  }
  /* a second line (hotel: the Lina undir text, room numbers: the small line) can remove sizes and so move the price up;
     say so under the choice, live (18.10, ostadfest 2c). '' when the line costs no sizes. */
  function linaTilkynning(ctx, s) {
    var p = P(ctx); if (!p.leturKlar) return '';
    var st = stadaAf(ctx, s), ho = hotel(ctx);
    if (ho ? !(erEigin(ctx, st) && st.undirA && trim(st.undir)) : st.undirVal === 'ekkert') return '';
    var st0 = afrit(st); if (ho) st0.undirA = false; else st0.undirVal = 'ekkert';
    var L1 = staerdirIBodi(ctx, st), L0 = staerdirIBodi(ctx, st0);
    if (!L1.length || L1.length >= L0.length) return '';
    var ein = L1.length === 1, txt = ein ? t(ctx, 'lina_faekkar_ein', { m: L0.length }) : t(ctx, 'lina_faekkar', { n: L1.length, m: L0.length });
    var v1 = finna(ctx, val(ctx, { staerd: L1[0], festing: festingA(ctx, L1[0], st.festing) })), v0 = finna(ctx, val(ctx, { staerd: L0[0], festing: festingA(ctx, L0[0], st.festing) }));
    if (v1 && v0 && v1.verd !== v0.verd) txt += ' ' + t(ctx, ein ? 'lina_verd_ein' : 'lina_verd', { a: kr(v1.verd), b: kr(v0.verd) });
    return txt;
  }
  function flatarmal(sz) { var S = H().STAERDIR[sz]; return S ? S.b * S.h : 0; }
  /* a change higher up never leaves an impossible later choice: the size moves to the nearest offered one (the
     smallest while the customer has not picked a size), glue where the size has no standoffs, a backing of the
     other tone than the plate. Quiet by design (owner 2026-10-01). */
  function normalisera(ctx) {
    var p = P(ctx), st = stadaAf(ctx, nuS(ctx)), k;
    if (p.gerd === 'akryl' && erDokkt(p.bak) === erDokkt(p.plata)) p.bak = erDokkt(p.plata) ? 'hvitt-glans' : 'svart-matt';
    if (hotel(ctx) && !erEigin(ctx, p) && !malGilt(ctx, p.skilti, p.mal, p.gerd)) p.mal = 'is';
    if (!p.leturKlar) return;
    if (!hotel(ctx) && p.undirVal !== 'ekkert' && undirIBodi(ctx, st).indexOf(p.undirVal) < 0) { p.undirVal = 'ekkert'; st = stadaAf(ctx, nuS(ctx)); }
    k = JSON.stringify(vels(ctx, st, { staerd: '*' })) + '|' + p.staerd + '|' + (p.staerdValin ? 1 : 0);
    if (k === p.normK) return;
    var fyrriSt = p.normK ? p.staerd : null;
    var listi = staerdirIBodi(ctx, st);
    if (listi.length && listi.indexOf(p.staerd) < 0) {
      var ny = listi[0];
      if (p.staerdValin) {
        var a0 = flatarmal(p.staerd), best = 1e18;
        listi.forEach(function (sz) { var d = Math.abs(flatarmal(sz) - a0) + (flatarmal(sz) < a0 ? 0.5 : 0); if (d < best) { best = d; ny = sz; } });
      }
      p.staerd = ny;
    } else if (listi.length && !p.staerdValin) p.staerd = listi[0];
    p.festing = festingA(ctx, p.staerd, p.festing);
    p.normK = JSON.stringify(vels(ctx, stadaAf(ctx, nuS(ctx)), { staerd: '*' })) + '|' + p.staerd + '|' + (p.staerdValin ? 1 : 0);
    /* P2-G1 21.10 (V12): when the line under the number (or the hotel's own second line) moved the size, and so the price, the
       customer hears and sees why (the same sentence as the help line of the step, a toast and the live region) */
    if (fyrriSt && fyrriSt !== p.staerd && ctx.tilkynna) {
      setTimeout(function () { var lt = linaTilkynning(ctx, nuS(ctx)); if (lt) ctx.tilkynna(lt); }, 0);
    }
  }
  function svgAf(ctx, s, o) {
    var U = uppsetning(ctx, s, o && o.anAthugunar ? { anAthugunar: true } : null);
    if (!U || !U.g) return '';
    var sma = !!(o && o.smamynd), bil = o && o.bil != null ? o.bil : 8;
    if (sma && s.gerd === 'stok') bil = Math.max(bil, STOK_BIL);
    var svg = H().teikna(U, { id: (o && o.id) || 'hb', slodir: (ctx.vel || {}).slodir, skuggi: !sma, smamynd: sma, merkja: !!(o && o.merkja), bil: bil, aria: '', pxmm: o && o.pxmm });
    return sma ? veggFlis(glansFlis(svg), s, bil) : svg;
  }
  /* white gloss in a tile: a stronger diagonal reflection than the big preview's sheen (V4 round 1) */
  var GLANS_STOR = '<stop offset="0" stop-color="#e9e9e7"/><stop offset=".38" stop-color="#fff"/><stop offset=".47" stop-color="#f4f4f2"/><stop offset=".53" stop-color="#fff"/><stop offset="1" stop-color="#ececea"/>',
    GLANS_FLIS = '<stop offset="0" stop-color="#d3d3cf"/><stop offset=".36" stop-color="#fff"/><stop offset=".45" stop-color="#dcdcd8"/><stop offset=".55" stop-color="#fff"/><stop offset="1" stop-color="#cfcfcb"/>';
  function glansFlis(svg) { return svg ? svg.split(GLANS_STOR).join(GLANS_FLIS) : svg; }
  /* tiles under the kit's 40 KB cap (15.10): SM Didot text is a finely flattened polyline (HERBERGI \u00b7 ROOM alone ~33 KB),
     so a Didot tile went over the cap and the kit showed its empty fallback. Pure M/L/Z paths are thinned with
     Ramer-Douglas-Peucker (closed outlines too); a tile is a few hundred px wide, so 0.04 mm is far below a pixel.
     Tiles only: the big preview and the production file (spec) never pass through here. */
  var FLIS_HAMARK = 36000;
  function rdp(P, e) {
    var n = P.length, keep, st, a, b, i, mx, mi, ax, ay, dx, dy, L, dd;
    if (n < 3) return P;
    keep = []; keep[0] = keep[n - 1] = 1; st = [[0, n - 1]];
    while (st.length) {
      b = st.pop(); a = b[0]; b = b[1]; mx = -1; mi = -1;
      ax = P[a][0]; ay = P[a][1]; dx = P[b][0] - ax; dy = P[b][1] - ay; L = Math.sqrt(dx * dx + dy * dy);
      for (i = a + 1; i < b; i++) {
        dd = L > 1e-6 ? Math.abs(dx * (P[i][1] - ay) - dy * (P[i][0] - ax)) / L : Math.sqrt((P[i][0] - ax) * (P[i][0] - ax) + (P[i][1] - ay) * (P[i][1] - ay));
        if (dd > mx) { mx = dd; mi = i; }
      }
      if (mx > e) { keep[mi] = 1; st.push([a, mi], [mi, b]); }
    }
    return P.filter(function (q, j) { return keep[j]; });
  }
  function smaD(d, e) {
    if (!/^[MLZ0-9 .\-]+$/.test(d)) return d;
    return d.split(/(?=M)/).map(function (sp) {
      var z = /Z\s*$/.test(sp), n = sp.replace(/[MLZ]/g, ' ').trim().split(/\s+/).map(Number), P = [], i;
      for (i = 0; i + 1 < n.length; i += 2) P.push([n[i], n[i + 1]]);
      if (!P.length) return sp;
      return rdp(P, e).map(function (q, j) { return (j ? 'L' : 'M') + (Math.round(q[0] * 100) / 100) + ' ' + (Math.round(q[1] * 100) / 100); }).join('') + (z ? 'Z' : '');
    }).join('');
  }
  function smaFlis(svg) {
    var e = 0.04;
    while (svg && svg.length > FLIS_HAMARK && e < 1) {
      svg = svg.replace(/ d="([^"]*)"/g, function (m, d) { return ' d="' + smaD(d, e) + '"'; });
      e *= 2;
    }
    return svg;
  }
  /* \u00c1n baks tiles: the plate on a piece of wall (dark behind a light plate, light behind a dark one) */
  var STOK_BIL = 9, VEGGUR_FLIS = { dokkur: '#5b5954', ljos: '#cbc8c1' };
  function veggFlis(svg, r, m) {
    if (!svg || !r || r.gerd !== 'stok') return svg;
    var b = /data-b="([0-9.]+)"/.exec(svg), h = /data-h="([0-9.]+)"/.exec(svg);
    if (!b || !h) return svg;
    var w = +b[1] + 2 * m, hh = +h[1] + 2 * m;
    return svg.replace('</defs>', '</defs><rect x="' + (-m) + '" y="' + (-m) + '" width="' + w.toFixed(2) + '" height="' + hh.toFixed(2) + '" rx="' + (m / 3).toFixed(2) + '" data-vs-herbergi-veggur fill="' + VEGGUR_FLIS[veggurAf(r)] + '"/>');
  }

  /* ---------------- names ---------------- */
  function heitiGerdar(ctx, k) { return t(ctx, 'gerd.' + k) || k; }
  function heitiStaerdar(ctx, k) { return t(ctx, 'staerd.' + k) || k; }
  function heitiFestingar(ctx, k) { return t(ctx, 'festing.' + k) || k; }
  /* P2-G1 21.10 (N02): outside Icelandic a ready hotel sign is NAMED by its English text from the template ("RECEPTION" ->
     "Reception"); the sign itself keeps the language chosen (Icelandic by default), data-nafn and the cart stay Icelandic */
  function erIs() { var l = document.documentElement.lang || ''; return !/^[a-z]/i.test(l) || /^is\b/i.test(l); }
  function synSkilti(T) {
    if (!T) return '';
    if (erIs() || !T.enska) return T.heiti;
    var e = String(T.enska).toLowerCase();
    return e.charAt(0).toUpperCase() + e.slice(1);
  }
  function heitiSkiltis(ctx, k) { var T = snid(ctx, k); return T ? synSkilti(T) : t(ctx, 'skilti.eigin'); }
  function litGildi(ctx, s) {
    if (s.gerd === 'tvilitt') return t(ctx, 'tvilitt.' + s.litur);
    if (s.gerd === 'akryl') return t(ctx, 'akryl.' + s.plata) + ' / ' + t(ctx, 'akryl.' + s.bak);
    return t(ctx, 'akryl.' + s.plata);
  }
  function veggurAf(s) {
    if (s.gerd === 'tvilitt') return (H() && H().TVILITT[s.litur] && H().TVILITT[s.litur].dokkt) ? 'ljos' : 'dokkur';
    return erDokkt(s.plata) ? 'ljos' : 'dokkur';
  }
  function aria(ctx, s) {
    var L = linur(ctx, s), up = H().upp;
    return t(ctx, 'aria', { tegund: hotel(ctx) ? heitiSkiltis(ctx, s.skilti) : t(ctx, 'tegund.numer'), gerd: heitiGerdar(ctx, s.gerd) + ', ' + litGildi(ctx, s), staerd: heitiStaerdar(ctx, s.staerd),
      texti: (L.takn ? taknHeiti(ctx, L.takn) + (L.texti ? ' / ' : '') : '') + up(L.texti) + (L.undir ? ' / ' + up(L.undir) : '') });
  }

  /* ---------------- checks (the kit contract: [{kodi, reitur, stopp, texti, hnappur, strax}]) ---------------- */
  function athugaS(ctx, s, fljott) {
    var p = P(ctx), ut = [], eigin = erEigin(ctx, s), nr = !hotel(ctx);
    if (!p.KODAR_OK || !finna(ctx, val(ctx, { gerd: s.gerd, staerd: s.staerd, festing: s.festing }))) { ut.push({ kodi: 'ekki_i_bodi', stopp: true, texti: t(ctx, 'ekki_i_bodi'), hnappur: t(ctx, 'ekki_i_bodi'), fyrst: true }); return ut; }
    if (p.leturVilla) { ut.push({ kodi: 'hledst_ekki', stopp: true, texti: t(ctx, 'hledst_ekki'), hnappur: t(ctx, 'ekki_i_bodi'), fyrst: true }); return ut; }
    if (eigin && vantarTexta(ctx, s)) ut.push({ kodi: 'vantar', reitur: 'texti', stopp: true, texti: t(ctx, nr ? 'vantar_numer_texti' : 'vantar_texti_texti'), hnappur: t(ctx, nr ? 'vantar_numer' : 'vantar_texti'), strax: !!p.snert });
    if (!p.leturKlar) { ut.push({ kodi: 'hledst', stopp: true, texti: t(ctx, 'hledst'), hnappur: ctx.t('baeta') || '', strax: false }); return ut; }
    if (erDidot(ctx, s) && p.didotVilla) { ut.push({ kodi: 'hledst_ekki', stopp: true, texti: t(ctx, 'hledst_ekki'), hnappur: t(ctx, 'ekki_i_bodi'), fyrst: true }); return ut; }
    if (erDidot(ctx, s) && !p.didotKlar) { ut.push({ kodi: 'hledst', stopp: true, texti: t(ctx, 'hledst'), hnappur: ctx.t('baeta') || '', strax: false }); return ut; }
    if (hotel(ctx) && !eigin && !p.taknKlar && snid(ctx, s.skilti) && snid(ctx, s.skilti).takn && !skoridGerd(s.gerd)) { ut.push({ kodi: 'hledst', stopp: true, texti: t(ctx, 'takn_hled'), hnappur: ctx.t('baeta') || '', strax: false }); return ut; }
    var U = uppsetning(ctx, s, fljott ? { anAthugunar: true } : null);
    if (!U) { ut.push({ kodi: 'hledst_ekki', stopp: true, texti: t(ctx, 'hledst_ekki'), hnappur: t(ctx, 'ekki_i_bodi') }); return ut; }
    var ofLangt = false;
    (U.villur || []).forEach(function (v) {
      var x = null;
      if (v.kodi === 'vantar_texti') return;
      if (v.kodi === 'hledst') x = { kodi: 'hledst', stopp: true, texti: t(ctx, 'hledst'), hnappur: ctx.t('baeta') || '', strax: false };
      else if (v.kodi === 'ogilt') x = { kodi: 'ogilt', reitur: 'texti', texti: /^\.( \.)*$/.test(v.takn) ? t(ctx, 'ogilt_punktur') : t(ctx, 'ogilt', { s: v.takn }), hnappur: t(ctx, 'ogilt_hnappur') };
      else if (v.kodi === 'festing') x = { kodi: 'festing', reitur: 'festing', texti: t(ctx, 'festing_skipt'), hnappur: t(ctx, 'ekki_i_bodi') };
      else { ofLangt = true; return; }
      x.stopp = true;
      if (x.strax == null) x.strax = true;
      ut.push(x);
    });
    /* the design fits no size at all (the sizes it fits are the only ones offered): the text is too long */
    if (!ut.length && !fljott && (ofLangt || !staerdirIBodi(ctx, s).length)) {
      var langt = { kodi: 'of_langt', reitur: 'texti', stopp: true, texti: t(ctx, nr ? 'of_langt_numer' : 'of_langt_hotel'), hnappur: t(ctx, 'of_langt_hnappur'), strax: true };
      if (!eigin) { langt.reitur = 'skilti'; langt.texti = t(ctx, 'of_langt_snid'); }
      ut.push(langt);
    }
    /* the production file was measured and refused for exactly this design (see skraAthuga) */
    if (!fljott && !ut.length && p.skraFall && p.skraFall === JSON.stringify(vels(ctx, s))) ut.push({ kodi: 'skra', reitur: 'texti', stopp: true, texti: t(ctx, 'skra_villa'), hnappur: t(ctx, 'of_langt_hnappur'), strax: true });
    return ut;
  }
  function athugaNu(ctx, s) {
    var p = P(ctx), st = stadaAf(ctx, s), k = JSON.stringify(vels(ctx, st)) + (p.skrifar ? '|f' : '') + (p.snert ? '|s' : '') + (p.leturKlar ? 1 : 0) + (p.didotKlar ? 1 : 0) + (p.didotVilla ? 1 : 0) + (p.taknKlar ? 1 : 0) + (p.skraFall || '');
    if (p.athK === k) return p.athV;
    p.athK = k; p.athV = athugaS(ctx, st, p.skrifar);
    return p.athV;
  }
  function reitVillur(ctx, s, reitir) { return athugaNu(ctx, s).filter(function (v) { return v.stopp && reitir.indexOf(v.reitur) >= 0; }); }

  /* ---------------- production file check (a cut design is built and measured in an idle slot) ---------------- */
  var hvild = window.requestIdleCallback ? function (f) { return window.requestIdleCallback(f, { timeout: 1200 }); } : function (f) { return setTimeout(f, 30); };
  /* SM Didot and its bridged version are not in the SMFram font table (sm-framleidsla.js): registered from the paths
     sm-framleidsla.liquid gives (SMFramSlodir.letur), exactly as sm-husnumer.js does */
  function skraDidot(F) {
    var c = window.SMFramSlodir, til = {};
    if (!F || !F.skraLetur || !c || !c.letur) return;
    try { til = F.letur() || {}; } catch (e) { til = {}; }
    DIDOT_IDS.forEach(function (id) {
      if (til[id] || !c.letur[id]) return;
      F.skraLetur(id, { nafn: id === 'smdidot-400' ? 'SM Didot' : 'SM Didot Bryr', thykkt: 400, url: c.letur[id],
        uppruni: id === 'smdidot-400' ? 'SM Didot: GFS Didot Regular (OFL 1.1, Greek Font Society) breikkad um 0,8 mm a 10 cm, sja sm-letur-smdidot-leyfi.txt' : 'smdidot-400 med stensilbruum' });
    });
  }
  function skraAthuga(ctx, s) {
    var p = P(ctx), F = window.SMFram;
    clearTimeout(p.skraTimi);
    if (!F || !F.bua || !H() || !p.leturKlar) return;
    var st = stadaAf(ctx, s);
    if (!skoridGerd(st.gerd)) return;
    var k = JSON.stringify(vels(ctx, st));
    if (has(p.skraMaelt, k)) return;
    p.skraTimi = setTimeout(function () {
      hvild(function () {
        var U = uppsetning(ctx, st);
        if (!U || !U.ok) return;
        var sp = null;
        try { sp = H().spec(U, [['S\u00ed\u00f0a', 'sm-vs-herbergi.js ' + (H().utgafa || '')]]); } catch (e) { sp = null; }
        if (!sp) return;
        if (erDidot(ctx, st)) skraDidot(F);
        p.skraMaelt[k] = 'bid';
        Promise.resolve(F.bua(sp, { tima: 8000 })).then(function (r) {
          var A = r && r.svg ? H().athugaSkra(r.svg, U) : null;
          p.skraMaelt[k] = A ? !!A.ok : true;
          if (A && !A.ok) { p.skraFall = k; if (window.console) console.warn('sm-vs-herbergi: skur\u00f0arskr\u00e1in st\u00f3\u00f0st ekki m\u00e6lingu', k); ctx.uppfaera(); }
        }, function () { delete p.skraMaelt[k]; });
      });
    }, 900);
  }

  /* ---------------- step bodies ---------------- */
  function tengja(el, ctx, breyting) {
    el.__hbBreyting = breyting;
    if (el.__hbTengt) return;
    el.__hbTengt = true;
    el.addEventListener('change', function (e) {
      var x = e.target;
      if (x && (x.type === 'radio' || x.type === 'checkbox') && el.__hbBreyting) el.__hbBreyting(x);
    });
  }
  function nafnSk(ctx, l) { return 'vs-' + ctx.id + '-hb-' + l; }
  function textaReitur(ctx, k) { var sk = ctx.skref('texti'); return sk && sk.el ? sk.el.querySelector('[data-vs-herbergi-texti="' + k + '"]') : null; }

  /* the tile's own step key. The language tiles (mal) are drawn INSIDE the Texti step, so the kit reports that step's key
     ('texti') in o.lykill, never 'mal': every language tile then fell through all the branches below and drew the current
     state, so all three showed the same sign (14.10). On the hotel page the Texti step's tiles are the language tiles. */
  function flisLyk(ctx, o) { return hotel(ctx) && o.lykill === 'texti' ? 'mal' : o.lykill; }
  /* utlit tiles: the page state with one tile applied */
  function flisS(ctx, s2, o) {
    var p = P(ctx), r = stadaAf(ctx, s2), g = o.gildi, hl, lyk = flisLyk(ctx, o);
    if (lyk === 'skilti') { r.skilti = g; if (!malGilt(ctx, g, r.mal, r.gerd)) r.mal = 'is'; }
    else if (lyk === 'mal') r.mal = g;
    else if (lyk === 'undir') r.undirVal = g;
    else if (lyk === 'letur') r.letur = g;
    else if (lyk === 'efni') {
      hl = String(g).split('|'); r.gerd = hl[0];
      if (r.gerd === 'tvilitt') r.litur = hl[1]; else r.plata = hl[1];
      if (r.gerd === 'akryl' && erDokkt(r.bak) === erDokkt(r.plata)) r.bak = erDokkt(r.plata) ? 'hvitt-glans' : 'svart-matt';
      if (hotel(ctx) && !erEigin(ctx, r) && !malGilt(ctx, r.skilti, r.mal, r.gerd)) r.mal = 'is';
      if (!hotel(ctx) && r.undirVal !== 'ekkert' && p.leturKlar && undirIBodi(ctx, r).indexOf(r.undirVal) < 0) r.undirVal = 'ekkert';
      r.rammi = r.gerd === 'tvilitt' && (p.gerd === 'tvilitt' ? rammiAf(s2, ctx, 'tvilitt') : p.rammiSidast !== 'an');
    } else if (lyk === 'bak') r.bak = g;
    else if (lyk === 'staerd') { r.staerd = g; r.festing = festingA(ctx, g, r.festing); }
    else if (lyk === 'festing') r.festing = festingA(ctx, r.staerd, g);
    else if (o.tegund === 'rammi') r.rammi = g === 'med' && r.gerd === 'tvilitt';
    /* a tile of another step than the size: shown on the first size it is offered on when the current one does not hold it */
    if (lyk !== 'staerd' && p.leturKlar && !passar(ctx, r, r.staerd)) {
      var ks = staerdirIBodi(ctx, r);
      if (ks.length) { r.staerd = ks[0]; r.festing = festingA(ctx, r.staerd, r.festing); }
    }
    return r;
  }
  function flisLykill(ctx, s2, o) {
    var r = flisS(ctx, s2, o);
    return flisLyk(ctx, o) + '|' + JSON.stringify(vels(ctx, r, { anAthugunar: true })) + (P(ctx).taknKlar ? 't' : '') + (P(ctx).leturKlar ? 'l' : '') + (P(ctx).didotKlar ? 'd' : '');
  }
  /* size cards: every offered size on one scale (the largest fills the card), on a common baseline */
  var SZ_BIL = 4;
  function staerdSvg(ctx, r, sz, o) {
    var S = H().STAERDIR[sz], K = { b: 0, h: 0 };
    (P(ctx).KODAR.staerd || []).forEach(function (x) { var Q = H().STAERDIR[x]; if (Q) { K.b = Math.max(K.b, Q.b); K.h = Math.max(K.h, Q.h); } });
    K.b += 2 * SZ_BIL; K.h += 2 * SZ_BIL;
    var vb = [-(K.b - S.b) / 2, -(K.h - S.h - SZ_BIL), K.b, K.h].map(function (n) { return Math.round(n * 100) / 100; }).join(' ');
    var U = uppsetning(ctx, r, { anAthugunar: true });
    if (!U || !U.g) return '';
    var svg = veggFlis(glansFlis(H().teikna(U, { id: o.id + 'z', slodir: (ctx.vel || {}).slodir, skuggi: false, smamynd: true, bil: SZ_BIL, aria: '' })), r, SZ_BIL);
    return svg.replace(/viewBox="[^"]*"/, 'viewBox="' + vb + '"').replace(/ width="[^"]*" height="[^"]*"/, '');
  }
  /* the text fields are K-reitur (lota 8): the number / own text, and the optional second line of an own text (hotel only) */
  function textaReitirHtml(ctx, id) {
    var nr = !hotel(ctx), at = { autocomplete: 'off', spellcheck: 'false', autocapitalize: 'characters', enterkeyhint: 'done' };
    return ctx.html.reitur({ id: id + '-adal', heiti: t(ctx, nr ? 'reitur.numer' : 'reitur.eigin'), hamark: nr ? 8 : 16, skylda: true, villa: false,
        attr: at, gogn: { 'vs-herbergi-texti': 'texti' } }) +
      ctx.html.rofi({ heiti: '', falid: true, fokus: id + '-undir-rofi', ytraGogn: { 'vs-herbergi-undir-val': true }, gogn: { 'vs-herbergi-undir-rofi': true } }) +
      ctx.html.reitur({ id: id + '-undir', heiti: t(ctx, 'undir_heiti'), sjonlaust: true, hamark: 30, villa: false, hjalp: t(ctx, 'eigin_undir_hjalp'),
        klasi: 'vs-herbergi-undir', reitGogn: { 'vs-herbergi-undir': true }, falid: true, attr: at, gogn: { 'vs-herbergi-texti': 'undir' } });
  }
  /* ---------------- takka-hamur (prufa ?view=prufa-hotel / prufa-herbergi, section stilling "takkar" -> data-takkar on .vs) ----------
     Owner spec 09.10: Grafid / Skorid switch; Skorid: Svart / Hvitt, Glans / Matt and the back (Hnota / Akryl, plus the existing
     "An baks"); Grafid: the two-tone colours as small colour dots and a Rammi button. The pills set the same page state as the Efni step
     and the kit's own frame radios do (ctx.takkar of the kit, same look as the door sign pills), so variant, price, cart properties and
     production file are the same. The steps Efni and Rammi are hidden (ctx.takkar fela); Bak (colour of the back plate), Festing and the
     text steps stay steps. Without data-takkar none of this runs. ---------------- */
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  function takkaRadio(ctx, l, f) {
    var s = ctx.skref(l), r = s && s.el ? s.el.querySelectorAll('input[type=radio]') : [], i;
    for (i = 0; i < r.length; i++) if (f(r[i])) return r[i];
    return null;
  }
  function takkaSmida(ctx) {
    var p = P(ctx), sidasta = 'hnota';
    function pil(k, tx, til, kv, smella) { return { k: k, t: tx, til: til, kv: kv, smella: smella }; }
    function skorid() { return p.gerd !== 'tvilitt'; }
    function plata(i, v) { var c = String(p.plata).split('-'); c[i] = v; p.plata = c.join('-'); ctx.breytt(); }
    function setGerd(g) { if (g !== 'tvilitt') sidasta = g; p.gerd = g; ctx.breytt(); }
    var teg = [pil('grafid', t(ctx, 'takki_grafid') || 'Grafi\u00f0', function () { if (skorid()) sidasta = p.gerd; return true; }, function () { return !skorid(); }, function (kv) { if (!kv) setGerd('tvilitt'); }),
      pil('skorid', t(ctx, 'takki_skorid') || 'Skori\u00f0', function () { return true; }, function () { return skorid(); }, function (kv) { if (!kv) setGerd(sidasta); })];
    var lit = [pil('plata-svart', t(ctx, 'takki_svart') || 'Svart', skorid, function () { return /^svart/.test(p.plata); }, function (kv) { if (!kv) plata(0, 'svart'); }),
      pil('plata-hvitt', t(ctx, 'takki_hvitt') || 'Hv\u00edtt', skorid, function () { return /^hvitt/.test(p.plata); }, function (kv) { if (!kv) plata(0, 'hvitt'); })];
    lit[0].punktur = 'svart'; lit[1].punktur = 'hvitt';
    var afer = [pil('plata-glans', t(ctx, 'takki_glans') || 'Glans', skorid, function () { return /glans$/.test(p.plata); }, function (kv) { if (!kv) plata(1, 'glans'); }),
      pil('plata-matt', 'Matt', skorid, function () { return /matt$/.test(p.plata); }, function (kv) { if (!kv) plata(1, 'matt'); })];
    var bakPunktur = { hnota: 'hnota', akryl: 'akryl', stok: 'an' };
    var bakhl = [['hnota', 'Hnota'], ['akryl', 'Akr\u00fdl'], ['stok', '\u00c1n baks']].map(function (g) {
      var x = pil('bakhlid-' + g[0], t(ctx, 'takki_' + (g[0] === 'stok' ? 'an_baks' : g[0])) || g[1], function () { return skorid() && (p.KODAR.gerd || []).indexOf(g[0]) >= 0; }, function () { return p.gerd === g[0]; }, function (kv) { if (!kv) setGerd(g[0]); });
      x.punktur = bakPunktur[g[0]];
      return x;
    });
    var tv = TVILITT_K.map(function (l) {
      var x = pil('tvilitt-' + l, t(ctx, 'tvilitt.' + l), function () { return !skorid(); }, function () { return p.litur === l; }, function (kv) { if (!kv) { p.litur = l; ctx.breytt(); } });
      x.punktur = l;
      return x;
    });
    var rammi = [pil('rammi', t(ctx, 'takki_rammi') || 'Rammi', function () { return !skorid(); },
      function () { var r = takkaRadio(ctx, 'rammi', function (x) { return x.checked; }); return !!r && r.value === 'med'; },
      function (kv) { var r = takkaRadio(ctx, 'rammi', function (x) { return x.value === (kv ? 'an' : 'med'); }); if (r) r.click(); })];
    /* the box drawing the preview needs its size again when the bar changes height */
    if (window.ResizeObserver && ctx.teikning) new ResizeObserver(function () { var r = ctx.teikning.getBoundingClientRect(); if (r.width + 'x' + r.height !== p.forskoStaerd) ctx.teiknaAftur(); }).observe(ctx.teikning);
    var bar = ctx.takkar({
      fela: ['efni', 'rammi'],
      hopar: [{ heiti: t(ctx, 'takkar_gerd') || 'Skor\u00f0 e\u00f0a grafi\u00f0', pillur: teg }, { heiti: t(ctx, 'takkar_litur') || 'Litur', punktar: true, pillur: lit }, { heiti: t(ctx, 'takkar_aferd') || '\u00c1fer\u00f0', pillur: afer }, { heiti: t(ctx, 'takkar_bakhlid') || 'Bakhli\u00f0', punktar: true, pillur: bakhl },
        { heiti: t(ctx, 'takkar_litur') || 'Litur', punktar: true, pillur: tv }, { heiti: t(ctx, 'takkar_rammi') || 'Rammi', pillur: rammi }]
    });
    return bar;
  }

  var SKREF = {
    /* hotel: the ready signs, each tile its own finished design, Eigin texti last */
    skilti: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = [];
        p.TEG_ROD.forEach(function (x) { k.push({ gildi: x, heiti: synSkilti(p.TEGUNDIR[x]), nafn: p.TEGUNDIR[x].heiti, valid: p.skilti === x }); });
        k.push({ gildi: 'eigin', heiti: t(ctx, 'skilti.eigin'), valid: p.skilti === 'eigin' });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'skilti'), birting: 'utlit', lykill: 'skilti', klasi: 'vs-herbergi-skilti', kostir: k }));
        tengja(el, ctx, function (x) { p.skilti = x.value; if (!malGilt(ctx, p.skilti, p.mal, p.gerd)) p.mal = 'is'; p.staerdValin = false; ctx.breytt(); });
      },
      gildi: function (s, ctx) { return heitiSkiltis(ctx, P(ctx).skilti); }
    },
    /* room numbers: the number; hotel: the language of a ready sign, or the own text with an optional second line */
    texti: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), st = stadaAf(ctx, s), id = nafnSk(ctx, 'texti'), eigin = erEigin(ctx, st), nr = !hotel(ctx);
        if (!el.__hbByggt) {
          el.__hbByggt = true;
          el.innerHTML = '<div data-vs-herbergi-mal hidden></div><div data-vs-herbergi-reitir>' + textaReitirHtml(ctx, id) + '</div>';
          textaAtburdir(el, ctx);
        }
        var q = function (sel) { return el.querySelector(sel); };
        var setT = function (e, x) { if (e && e.textContent !== x) e.textContent = x; };
        var malEl = q('[data-vs-herbergi-mal]'), reitir = q('[data-vs-herbergi-reitir]');
        malEl.hidden = eigin; reitir.hidden = !eigin;
        if (!eigin) {
          var kost = malKostir(ctx, st.skilti, st.gerd).map(function (m) { return { gildi: m, heiti: t(ctx, 'mal.' + m), valid: (malGilt(ctx, st.skilti, st.mal, st.gerd) ? st.mal : 'is') === m }; });
          ctx.html.setja(malEl, ctx.html.kostir({ nafn: nafnSk(ctx, 'mal'), birting: 'utlit', lykill: 'mal', klasi: 'vs-herbergi-mal', kostir: kost }));
        }
        var inp = q('[data-vs-herbergi-texti="texti"]');
        if (inp.value !== p.texti && document.activeElement !== inp) inp.value = p.texti;
        inp.placeholder = t(ctx, nr ? 'daemi.numer' : 'daemi.eigin');
        inp.maxLength = nr ? 8 : 16;
        el.setAttribute('data-vs-hastafir', '');
        var sk = ctx.skref('texti');
        if (sk && sk.el) inp.setAttribute('aria-describedby', sk.el.id + '-hjalp ' + sk.el.id + '-villa');
        var villa = reitVillur(ctx, s, ['texti', 'undir']).filter(function (v) { return ctx.reynt() || v.strax; });
        if (villa.some(function (v) { return v.reitur === 'texti'; })) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
        /* the optional second line of an own text (hotel only) */
        var rofiL = q('[data-vs-herbergi-undir-val]'), rofi = q('[data-vs-herbergi-undir-rofi]');
        rofiL.hidden = nr;
        if (rofi.checked !== !!p.undirA) rofi.checked = !!p.undirA;
        setT(q('[data-vs-herbergi-undir-val] .vs-rofi-heiti'), t(ctx, 'eigin_undir_rofi'));
        var ur = q('[data-vs-herbergi-undir]'); ur.hidden = nr || !p.undirA;
        var ui = q('[data-vs-herbergi-texti="undir"]');
        if (ui.value !== p.undir && document.activeElement !== ui) ui.value = p.undir;
        ui.placeholder = t(ctx, 'daemi.eigin_undir');
        if (villa.some(function (v) { return v.reitur === 'undir'; })) ui.setAttribute('aria-invalid', 'true'); else ui.removeAttribute('aria-invalid');
        tengja(el, ctx, function (x) {
          if (x.hasAttribute('data-vs-herbergi-undir-rofi')) {
            p.undirA = !!x.checked;
            ctx.breytt();
            if (p.undirA) { var u2 = textaReitur(ctx, 'undir'); if (u2) setTimeout(function () { try { u2.focus({ preventScroll: true }); } catch (e) {} }, 0); }
            return;
          }
          if (x.name === nafnSk(ctx, 'mal')) { p.mal = x.value; ctx.breytt(); }
        });
      },
      gildi: function (s, ctx) {
        var st = stadaAf(ctx, s), L = linur(ctx, st);
        if (hotel(ctx) && !erEigin(ctx, st)) return t(ctx, 'mal.' + (malGilt(ctx, st.skilti, st.mal, st.gerd) ? st.mal : 'is'));
        return L.syni ? '' : H().upp(L.texti) + (L.undir ? ' / ' + H().upp(L.undir) : '');
      },
      buid: function (s, ctx) { return !reitVillur(ctx, s, ['texti', 'undir']).length; },
      fokus: function (el, kodi, ctx) {
        var undir = /^undir/.test(kodi || '') && P(ctx).undirA;
        return el.querySelector('[data-vs-herbergi-texti="' + (undir ? 'undir' : 'texti') + '"]') || el.querySelector('input:checked') || el.querySelector('input');
      }
    },
    /* room numbers: the small engraved line under the number */
    undir: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = undirIBodi(ctx, stadaAf(ctx, s)).map(function (u) { return { gildi: u, heiti: u === 'ekkert' ? t(ctx, 'undir.ekkert') : undirTexti(ctx, u), valid: p.undirVal === u }; });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'undir'), birting: 'utlit', lykill: 'undir', klasi: 'vs-herbergi-undirval', kostir: k }));
        tengja(el, ctx, function (x) { p.undirVal = x.value; ctx.breytt(); });
      },
      gildi: function (s, ctx) { var u = P(ctx).undirVal; return u === 'ekkert' ? t(ctx, 'undir.ekkert') : undirTexti(ctx, u); }
    },
    /* room numbers: the font, two tiles (the number in each font on the chosen material), both always offered */
    letur: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = LETUR_K.map(function (l) { return { gildi: l, heiti: leturSyn(ctx, l), nafn: leturHeiti(ctx, l), valid: p.letur === l }; });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'letur'), birting: 'utlit', lykill: 'letur', klasi: 'vs-herbergi-letur', kostir: k }));
        tengja(el, ctx, function (x) {
          p.letur = LETUR_K.indexOf(x.value) >= 0 ? x.value : 'reo';
          if (p.letur === 'didot' && window.SMFram) { skraDidot(window.SMFram); try { window.SMFram.forhlada(DIDOT_IDS); } catch (e) {} }
          ctx.breytt();
        });
      },
      gildi: function (s, ctx) { return leturSyn(ctx, P(ctx).letur); }
    },
    efni: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = [];
        (p.KODAR.gerd || []).forEach(function (g) {
          var v = finna(ctx, val(ctx, { gerd: g })) || finna(ctx, val(ctx, { gerd: g, festing: 'lim' })), verd = v ? kr(v.verd) : '';
          (g === 'tvilitt' ? TVILITT_K : AKRYL_K).forEach(function (l) {
            var gl = g + '|' + l, valid = p.gerd === g && (g === 'tvilitt' ? p.litur === l : p.plata === l);
            k.push({ gildi: gl, heiti: t(ctx, (g === 'tvilitt' ? 'tvilitt.' : 'akryl.') + l), hopur: heitiGerdar(ctx, g), hopur_skyring: verd, valid: valid, ovirkt: !v });
          });
        });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'efni'), birting: 'utlit', lykill: 'efni', klasi: 'vs-herbergi-efni', kostir: k }));
        tengja(el, ctx, function (x) {
          var hl = String(x.value).split('|');
          p.gerd = hl[0];
          if (p.gerd === 'tvilitt') p.litur = hl[1]; else p.plata = hl[1];
          ctx.breytt();
        });
        umEfnid(ctx);
      },
      gildi: function (s, ctx) { var p = P(ctx); return heitiGerdar(ctx, p.gerd) + ', ' + (p.gerd === 'tvilitt' ? t(ctx, 'tvilitt.' + p.litur) : t(ctx, 'akryl.' + p.plata)); }
    },
    bak: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = AKRYL_K.filter(function (l) { return erDokkt(l) !== erDokkt(p.plata); }).map(function (l) { return { gildi: l, heiti: t(ctx, 'akryl.' + l), valid: p.bak === l }; });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'bak'), birting: 'utlit', lykill: 'bak', klasi: 'vs-herbergi-tvo', kostir: k }));
        tengja(el, ctx, function (x) { p.bak = x.value; ctx.breytt(); });
      },
      gildi: function (s, ctx) { return t(ctx, 'akryl.' + P(ctx).bak); }
    },
    /* only the sizes the design is offered on; every card drawn with the design on that size */
    staerd: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), st = stadaAf(ctx, s), listi = staerdirIBodi(ctx, st);
        if (!listi.length) listi = (p.KODAR.staerd || []).slice();
        var k = listi.map(function (sz) {
          var v = finna(ctx, val(ctx, { staerd: sz, festing: festingA(ctx, sz, p.festing) }));
          return { gildi: sz, heiti: heitiStaerdar(ctx, sz), valid: p.staerd === sz, undir: v ? kr(v.verd) : '' };
        });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'staerd'), birting: 'utlit', lykill: 'staerd', klasi: 'vs-herbergi-staerd', kostir: k }));
        tengja(el, ctx, function (x) { p.staerd = x.value; p.staerdValin = true; p.festing = festingA(ctx, p.staerd, p.festing); ctx.breytt(); });
      },
      gildi: function (s, ctx) { return heitiStaerdar(ctx, P(ctx).staerd); }
    },
    festing: {
      teikna: function (el, s, ctx) {
        var p = P(ctx), k = (p.KODAR.festing || []).map(function (f) {
          var v = finna(ctx, val(ctx, { festing: f })), d = munur(ctx, {}, { festing: f });
          return { gildi: f, heiti: heitiFestingar(ctx, f), valid: p.festing === f, ovirkt: !v, undir: !v ? '' : (f === p.festing || !d ? '' : munurKr(d)) };
        }).filter(function (x) { return !x.ovirkt; });
        ctx.html.setja(el, ctx.html.kostir({ nafn: nafnSk(ctx, 'festing'), birting: 'utlit', lykill: 'festing', klasi: 'vs-herbergi-festing', kostir: k }));
        tengja(el, ctx, function (x) { p.festing = x.value; ctx.breytt(); });
      },
      gildi: function (s, ctx) { return heitiFestingar(ctx, P(ctx).festing); }
    }
  };
  /* typing: state, emoji out, pasted text cut to the field length; fast checks while typing, full ones after a pause */
  function textaAtburdir(el, ctx) {
    var p = P(ctx);
    function hreinsa(inp) {
      var v = inp.value || '', n = v.replace(TAKN_RE, '').replace(/[\r\n\t]+/g, ' ');
      if (n === v) return false;
      var pos = typeof inp.selectionStart === 'number' ? inp.selectionStart : v.length, ny = v.slice(0, pos).replace(TAKN_RE, '').length;
      inp.value = n;
      try { if (document.activeElement === inp) inp.setSelectionRange(ny, ny); } catch (e) {}
      return true;
    }
    function lesa(inp) {
      var k = inp.getAttribute('data-vs-herbergi-texti');
      if (hreinsa(inp)) ctx.tilkynna(t(ctx, 'emoji'), true);
      p[k] = inp.value || '';
      if (k === 'texti' && trim(p.texti)) p.snert = true;
    }
    function fullt() { clearTimeout(p.fulltTimi); p.skrifar = false; }
    el.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp || !inp.hasAttribute || !inp.hasAttribute('data-vs-herbergi-texti') || e.isComposing) return;
      lesa(inp);
      p.skrifar = true;
      clearTimeout(p.fulltTimi);
      p.fulltTimi = setTimeout(function () { p.skrifar = false; ctx.breytt(); }, FULLT_BID);
      ctx.teiknaAftur();
    });
    el.addEventListener('compositionend', function (e) { var inp = e.target; if (inp && inp.hasAttribute && inp.hasAttribute('data-vs-herbergi-texti')) { lesa(inp); ctx.teiknaAftur(); ctx.uppfaera(); } });
    el.addEventListener('paste', function (e) {
      var inp = e.target;
      if (!inp || !inp.hasAttribute || !inp.hasAttribute('data-vs-herbergi-texti')) return;
      var cd = e.clipboardData || window.clipboardData, txt = cd && cd.getData ? cd.getData('text') : null;
      if (txt == null) return;
      txt = String(txt).replace(TAKN_RE, '').replace(/\r\n|\r|\n|\t/g, ' ');
      var v = inp.value || '', s0 = inp.selectionStart || 0, s1 = inp.selectionEnd || 0, max = inp.maxLength;
      var pl = max > 0 ? Math.max(0, max - (v.length - (s1 - s0))) : txt.length;
      if (txt.length > pl) {
        e.preventDefault();
        inp.value = v.slice(0, s0) + txt.slice(0, pl) + v.slice(s1);
        try { inp.setSelectionRange(s0 + pl, s0 + pl); } catch (x) {}
        ctx.tilkynna(t(ctx, 'klippt', { n: max }), true);
        lesa(inp); fullt(); ctx.breytt();
      }
    });
    el.addEventListener('focusout', function (e) {
      var inp = e.target;
      if (!inp || !inp.hasAttribute || !inp.hasAttribute('data-vs-herbergi-texti')) return;
      if (inp.getAttribute('data-vs-herbergi-texti') === 'texti') p.snert = true;
      if (p.skrifar) { fullt(); ctx.breytt(); } else ctx.uppfaera();
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' && p.skrifar) { fullt(); ctx.uppfaera(); } });
  }
  function ariaDom(ctx) {
    var villa = reitVillur(ctx, nuS(ctx), ['texti', 'undir']).filter(function (v) { return ctx.reynt() || v.strax; });
    ['texti', 'undir'].forEach(function (k) {
      var inp = textaReitur(ctx, k);
      if (!inp) return;
      if (villa.some(function (v) { return v.reitur === k; })) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
    });
  }
  /* "Um efni\u00f0": the text of the chosen material */
  function umEfnid(ctx) {
    var p = P(ctx), el = ctx.rot.querySelector('[data-vs-efni-grunnur]');
    if (!el) return;
    var h = [t(ctx, (hotel(ctx) ? 'efni_hotel.' : 'efni_texti.') + p.gerd)].concat(!hotel(ctx) && p.gerd !== 'tvilitt' ? [t(ctx, 'efni_bryr')] : []).filter(Boolean).map(function (x) { return '<p>' + esc(x) + '</p>'; }).join('');
    if (h && el.__hb !== h) { el.innerHTML = h; el.__hb = h; el.hidden = false; }
  }

  /* ---------------- the preview: every size on one scale ---------------- */
  function teiknaForsko(ctx, s) {
    var p = P(ctx), st = stadaAf(ctx, s), box = ctx.teikning, r = box.getBoundingClientRect(), w = r.width, hh = r.height;
    var S = H() && H().STAERDIR[st.staerd];
    if (!S || !w || !hh) { box.innerHTML = svgAf(ctx, st, { merkja: true, anAthugunar: p.skrifar }); return; }
    /* 18.10 (eigandi: skiltid of litid i forskoduninni): staersta platan (290x190) fyllir flotinn, staerdarmunurinn er thjappadur
       (synileg staerd = rot af flatarmali fylgir rotinni af raunhlutfallinu) og minnsta platan (90x90) er minnst 45 % af breidd
       forskodunarrammans a sima, 35 % a tolvu; hinar radast a milli (log-bruun) svo staerri plata er staerri. Adur: 0,56 af
       styttri hlid flatarins, svo 90x90 var um 30 % af breiddinni. Aldrei ut fyrir flotinn. */
    var bil = 16, kStor = Math.min(w / (290 + bil), hh / (190 + bil));
    var sMax = Math.sqrt(290 * 190), sMin = 90, sP = Math.sqrt(S.b * S.h);
    var dMax = sMax * kStor, dMin = sMin * kStor * Math.sqrt(sMax / sMin);
    var rammiEl = box.closest ? box.closest('.vs-rammi') : null;
    if (rammiEl && rammiEl.clientWidth) dMin = Math.max(dMin, rammiEl.clientWidth * (window.innerWidth > 1000 ? 0.35 : 0.45));
    /* FG 21.10 (eigandi 18.10, hotelskilti a tolvu of litid eftir FB C1): a tolvu fyllir sjalfgefna hotelplatan (14 x 9) um 78 %
       af breidd rammans eins og adur; dMin reiknad svo 140x90 lendi thar, adrar staerdir radast eins og fyrr (stoerri plata stoerri,
       aldrei ut fyrir flotinn). Simi og herbergisnumer obreytt. */
    if (hotel(ctx) && rammiEl && rammiEl.clientWidth && window.innerWidth > 1000 && dMax > dMin) {
      var s14 = Math.sqrt(140 * 90), t14 = Math.log(s14 / sMin) / Math.log(sMax / sMin), k14 = rammiEl.clientWidth * 0.78 / 140;
      dMin = Math.max(dMin, Math.pow(k14 * s14 / Math.pow(dMax, t14), 1 / (1 - t14)));
    }
    dMin = Math.min(dMin, dMax);
    var tB = Math.max(0, Math.min(1, Math.log(sP / sMin) / Math.log(sMax / sMin)));
    var k = dMin * Math.pow(dMax / dMin, tB) / sP;
    k = Math.min(k, w / (S.b + bil), hh / (S.h + bil));
    var svg = svgAf(ctx, st, { merkja: !p.skrifar, anAthugunar: p.skrifar, id: 'hbf', pxmm: k });
    if (!svg) { box.innerHTML = ''; return; }
    var VW = w / k, VH = hh / k, vb = [S.b / 2 - VW / 2, S.h / 2 - VH / 2, VW, VH].map(function (n) { return Math.round(n * 100) / 100; }).join(' ');
    svg = svg.replace(/viewBox="[^"]*"/, 'viewBox="' + vb + '"').replace(/ width="[^"]*" height="[^"]*"/, ' overflow="visible"');
    if (p.forskoSvg !== svg) { box.innerHTML = svg; p.forskoSvg = svg; }
    p.forskoStaerd = w + 'x' + hh;
  }

  /* ---------------- cart properties (same keys as before) ---------------- */
  function eiginleikar(s, ctx) {
    var st = stadaAf(ctx, s), ut = [], A = H().AKRYL, TV = H().TVILITT, L = linur(ctx, st), up = H().upp;
    if (!L.syni && L.texti) ut.push([hotel(ctx) ? EIG.texti : EIG.numer, up(L.texti)]);
    if (L.undir) ut.push([EIG.undir, up(L.undir)]);
    if (L.takn) ut.push([EIG.takn, taknHeiti(ctx, L.takn)]);
    if (!hotel(ctx)) { var lk = erDidot(ctx, st) ? 'didot' : 'reo'; ut.push([EIG.letur, leturHeiti(ctx, lk)]); ut.push(['_letur', LETUR_ID[lk]]); }
    if (st.gerd === 'tvilitt') {
      ut.push([EIG.litur, TV[st.litur].heiti]);
      var rsk = ctx.skref('rammi'), rr = rsk && rsk.el && !rsk.el.hidden ? rsk.el.querySelector('input[type=radio]:checked') : null;
      if (rr) ut.push([ctx.eiginleiki('rammi') || EIG.rammi, rr.getAttribute('data-nafn') || '']);
    } else {
      ut.push([EIG.plata, A[st.plata].heiti]);
      if (st.gerd === 'akryl') ut.push([EIG.bak, A[st.bak].heiti]);
    }
    if (trim(s.aths)) ut.push([ctx.eiginleiki('aths') || EIG.aths, trim(s.aths)]);
    return ut;
  }

  /* ---------------- start ---------------- */
  function hladaTaknum(ctx) {
    var p = P(ctx), sl = (ctx.vel || {}).slodir || {};
    if (!H() || !H().hladaTakn || !sl.takn) { p.taknVilla = true; return; }
    H().hladaTakn(sl.takn).then(function () {
      p.TK_LISTI = H().takn(); p.TKM = {}; p.TK_LISTI.forEach(function (T) { p.TKM[T.kodi] = T; });
      p.taknKlar = true; p.taknVilla = false; p.skyndi = {}; p.skyndiRod = []; p.passarSk = {}; p.passarRod = []; p.athK = null; p.normK = '';
      ctx.breytt(); ctx.flisar();
    })['catch'](function (e) { p.taknVilla = true; ctx.breytt(); if (window.console) console.warn('sm-vs-herbergi: ' + (e && e.message)); });
  }
  function hladaLetur(ctx) {
    var p = P(ctx);
    if (p.hladid) return p.hladid;
    if (!H()) { p.leturVilla = true; return (p.hladid = Promise.resolve()); }
    var L = H().LETUR;
    p.hladid = H().hlada([L.reo]).then(function () {
      p.leturKlar = true; p.leturVilla = false; p.athK = null; p.normK = '';
      if (hotel(ctx)) hladaTaknum(ctx);
      else hladaDidot(ctx);
    })['catch'](function (e) {
      if (!p.leturKlar) p.leturVilla = true;
      if (window.console) console.warn('sm-vs-herbergi: ' + (e && e.message));
    });
    return p.hladid;
  }
  function hladaDidot(ctx) {
    var p = P(ctx), B = H().LETUR_BRYR;
    if (!B || p.didotBid) return;
    p.didotBid = true;
    H().hlada([H().LETUR.didot, B.didot]).then(function () {
      p.didotKlar = true; p.didotVilla = false; p.skyndi = {}; p.skyndiRod = []; p.passarSk = {}; p.passarRod = []; p.athK = null; p.normK = '';
      ctx.breytt(); ctx.flisar();
    })['catch'](function (e) {
      p.didotVilla = true; p.didotBid = false; p.athK = null; ctx.breytt();
      if (window.console) console.warn('sm-vs-herbergi: ' + (e && e.message));
    });
  }
  function slodP() {
    var o = {};
    try { (window.location.search || '').replace(/^\?/, '').split('&').forEach(function (x) { var a = x.split('='); if (a[0]) o[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || ''); }); } catch (e) {}
    return o;
  }

  /* ---- forsida B (15.10.2026, assets/sm-hero-lifandi.js): the number typed in the home page hero (Hotel tab). It never
     travels in the URL (M3): the hero keeps localStorage "sm-forsida-hotel" = {numer, t} and its link carries fra=forsida.
     Read once at start, only with that marker and within 30 minutes, then removed; it goes into the empty Texti field as if
     typed (an input event: the same handler as typing, so the drawing, the checks and the price follow), cut to the
     field length as a paste would be. A field that already holds a value is never overwritten. ---- */
  function fraForsidu(lykill) {
    try {
      if (!/[?&]fra=forsida(&|$)/.test(window.location.search || '')) return null;
      var f = JSON.parse(window.localStorage.getItem(lykill) || 'null');
      window.localStorage.removeItem(lykill);
      return (f && +f.t > 0 && Date.now() - f.t < 1800000) ? f : null;
    } catch (e) { return null; }
  }
  function fyllaFraForsidu(ctx, f) {
    var v = trim(String(f.numer || '').replace(/\s+/g, ' ')), n = 0;
    if (!v) return;
    (function reyna() {
      var inp = textaReitur(ctx, 'texti');
      if (!inp) { if (++n < 150) setTimeout(reyna, 100); return; }
      if (trim(inp.value) || trim(P(ctx).texti)) return;
      inp.value = inp.maxLength > 0 ? v.slice(0, inp.maxLength) : v;
      var ev;
      try { ev = new Event('input', { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('input', true, false); }
      inp.dispatchEvent(ev);
    })();
  }

  var A = {
    gerd: 'svg', skuggi: false, fylla: true, lifandi: true,
    skref: SKREF,
    upphaf: function (ctx) {
      var stl = ctx.stillingar || {}, q = slodP();
      var p = ctx.hb = {
        snid: stl.snid === 'hotel' ? 'hotel' : 'numer',
        TEGUNDIR: {}, TEG_ROD: [], TKM: {}, TK_LISTI: [], taknKlar: false, taknVilla: false, leturKlar: false, leturVilla: false,
        skyndi: {}, skyndiRod: [], passarSk: {}, passarRod: [], normK: '', skraMaelt: {}, skraFall: '',
        texti: '', undirA: false, undir: '', undirVal: UNDIR_K.indexOf(q.undir) >= 0 ? q.undir : 'ekkert',
        letur: LETUR_K.indexOf(q.letur) >= 0 ? q.letur : 'reo', didotKlar: false, didotVilla: false, didotBid: false, LETUR_HEITI: stl.letur_heiti || {},
        skilti: 'eigin', mal: MAL_K.indexOf(q.mal) >= 0 ? q.mal : 'is',
        gerd: 'hnota', staerd: '140x140', festing: 'lim', staerdValin: false,
        plata: AKRYL_K.indexOf(q.plata) >= 0 ? q.plata : 'svart-matt',
        bak: AKRYL_K.indexOf(q.bak) >= 0 ? q.bak : 'hvitt-glans',
        litur: TVILITT_K.indexOf(q.litur) >= 0 ? q.litur : 'gull',
        snert: false, skrifar: false, rammiSidast: ''
      };
      (stl.tegundir || []).forEach(function (x) { if (x && x.k && x.heiti) { p.TEGUNDIR[x.k] = x; p.TEG_ROD.push(x.k); } });
      if (hotel(ctx)) p.skilti = q.skilti && (q.skilti === 'eigin' || p.TEGUNDIR[q.skilti]) ? q.skilti : (p.TEG_ROD[0] || 'eigin');
      lesaKoda(ctx);
      if (erTakkar(ctx) && ctx.takkar) p.takkaBar = takkaSmida(ctx);
      /* start: the page's variant (?variant= or the readable params), else the template's default material and size */
      var v0 = ctx.afbrigdi, sj = stl.sjalfgefid || {};
      if (v0 && (q.variant || ctx.afbUrSlod)) {
        p.gerd = kodiAf(ctx, 'gerd', v0.n[p.IX.gerd]) || p.gerd;
        p.staerd = kodiAf(ctx, 'staerd', v0.n[p.IX.staerd]) || p.staerd;
        p.festing = kodiAf(ctx, 'festing', v0.n[p.IX.festing]) || p.festing;
        p.staerdValin = true;
      } else {
        if (sj.gerd && has(H() ? H().GERDIR : {}, sj.gerd)) p.gerd = sj.gerd;
        if (sj.staerd && has(H() ? H().STAERDIR : {}, sj.staerd)) p.staerd = sj.staerd;
      }
      if (erDokkt(p.bak) === erDokkt(p.plata)) p.bak = erDokkt(p.plata) ? 'hvitt-glans' : 'svart-matt';
      var tm = 0;
      window.addEventListener('resize', function () {
        clearTimeout(tm);
        tm = setTimeout(function () { var r = ctx.teikning.getBoundingClientRect(); if (r.width + 'x' + r.height !== p.forskoStaerd) ctx.teiknaAftur(); }, 120);
      });
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        ['texti', 'undir'].forEach(function (k) { var inp = textaReitur(ctx, k); if (inp) p[k] = inp.value || ''; });
        ctx.breytt();
      });
      var fs = fraForsidu('sm-forsida-hotel');
      if (fs) fyllaFraForsidu(ctx, fs);
    },
    hlada: function (ctx) { return hladaLetur(ctx); },
    /* FG 21.10: the letters are cut outlines (no text in the drawing), so the fields name the font: SM Didot or Rounded Elegance */
    reitLetur: function (el, s, ctx) { return { id: erDidot(ctx, P(ctx)) ? LETUR_ID.didot : LETUR_ID.reo }; },
    afbrigdi: function (s, ctx) {
      normalisera(ctx);
      var v = finna(ctx, val(ctx, {}));
      return v ? { vara: ctx.vara().handle, id: v.id } : null;
    },
    syna: function (lykill, s, ctx) {
      var p = P(ctx);
      if (lykill === 'letur') return !hotel(ctx);
      if (lykill === 'bak') return p.gerd === 'akryl';
      if (lykill === 'skilti') return hotel(ctx);
      if (lykill === 'undir') return !hotel(ctx);
      /* a step with one real choice is hidden: glue only where the size has no standoffs */
      if (lykill === 'festing') return tappar(p.staerd) > 0;
      return undefined;
    },
    rammi: function (s, ctx) {
      var p = P(ctx);
      if (s && (s.rammi === 'med' || s.rammi === 'an')) p.rammiSidast = s.rammi;
      /* two-tone only (owner rule 2026-09-30); cut and engraved acrylic have no frame */
      return p.gerd === 'tvilitt' ? { gerd: 'lina', inset: 3, insetY: 3, r: 1.5, form: 'rett', verd: 'okeypis' } : null;
    },
    teikna: function (ctx, s) {
      if (!H()) return;
      normalisera(ctx);
      if (P(ctx).takkaBar) P(ctx).takkaBar.uppfaera();
      teiknaForsko(ctx, s);
      if (!P(ctx).skrifar) skraAthuga(ctx, s);
    },
    lysing: function (s, ctx) { return H() && P(ctx).leturKlar ? aria(ctx, stadaAf(ctx, s)) : ''; },
    /* 14.10 (samraeming): "Daemi" flagan a myndinni (kitid teiknar hana) medan synishornid er teiknad en ekkert hefur verid skrifad */
    /* 16.10 (hero-nafn-fylgir): the page state (stadaAf) carries the typed text; the kit's s does not, so the flag never left */
    daemi: function (s, ctx) { return linur(ctx, stadaAf(ctx, s)).syni ? (hotel(ctx) ? ((ctx && ctx.vel && ctx.vel.ord && ctx.vel.ord.daemi_merki) || 'Dæmi, skrifaðu þinn texta') : ((ctx && ctx.vel && ctx.vel.ord && ctx.vel.ord.daemi_merki_numer) || 'Dæmi, sláðu inn þitt númer')) : false; },
    malband: function (s, ctx) { var p = P(ctx), S = H() && H().STAERDIR[p.staerd]; return S ? { b: S.b / 10, h: S.h / 10, eining: 'cm', texti: heitiStaerdar(ctx, p.staerd) } : null; },
    smamynd: function (s, ctx) { return { svg: svgAf(ctx, stadaAf(ctx, s), { smamynd: true, bil: 3, id: 'hbk' }) }; },
    veggur: function (s, ctx) { return veggurAf(stadaAf(ctx, s)); },
    athuga: function (s, ctx) {
      normalisera(ctx);
      var v = athugaNu(ctx, s);
      /* the kit knows the steps by key: a problem of the second line belongs to the Texti step */
      return v.map(function (x) { var y = afrit(x); if (y.reitur === 'undir') { y.reitur = 'texti'; if (!/^undir/.test(y.kodi)) y.kodi = 'undir_' + y.kodi; } return y; });
    },
    hjalp: function (s, ctx) {
      var p = P(ctx), f = {}, ho = hotel(ctx);
      f.skilti = t(ctx, 'skilti_hjalp');
      f.texti = ho ? (erEigin(ctx, p) ? t(ctx, 'hjalp.eigin') : t(ctx, 'mal_hjalp')) : t(ctx, 'hjalp.numer');
      f.undir = t(ctx, 'undir_hjalp');
      var lt = linaTilkynning(ctx, s);
      if (lt) { if (ho) f.texti += ' ' + lt; else f.undir += ' ' + lt; }
      f.letur = (ctx.stillingar && ctx.stillingar.letur_hjalp) || '';
      f.efni = t(ctx, (ho ? 'gerd_hotel.' : 'gerd_lys.') + p.gerd);
      f.bak = t(ctx, 'bak_hjalp');
      f.staerd = t(ctx, 'staerd_hjalp');
      f.festing = p.festing !== 'lim' && tappar(p.staerd) ? t(ctx, p.gerd === 'hnota' || p.gerd === 'akryl' ? 'festing_hjalp_lag' : 'festing_hjalp', { n: tappar(p.staerd) }) : '';
      return f;
    },
    vandamal: function (v, ctx) { ariaDom(ctx); },
    eiginleikar: function (s, ctx) { return eiginleikar(s, ctx); },
    skrar: function () { return []; },
    /* the readable address: never typed text */
    slod: function (s, ctx) {
      var p = P(ctx), o = { plata: null, bak: null, litur: null, undir: null, letur: null, skilti: null, mal: null };
      if (p.gerd === 'tvilitt') o.litur = p.litur; else { o.plata = p.plata; if (p.gerd === 'akryl') o.bak = p.bak; }
      if (!hotel(ctx)) { if (p.undirVal !== 'ekkert') o.undir = p.undirVal; if (p.letur === 'didot') o.letur = 'didot'; }
      else { o.skilti = p.skilti; if (!erEigin(ctx, p) && p.mal !== 'is') o.mal = p.mal; }
      return o;
    },
    framleidsla: function (s, ctx) {
      var p = P(ctx), st = stadaAf(ctx, s), U = uppsetning(ctx, st);
      if (!U || !U.ok) return null;
      var sp = H().spec(U, [['S\u00ed\u00f0a', 'sm-vs-herbergi.js ' + (H().utgafa || '') + (hotel(ctx) ? ' hotel' : ' numer')]]);
      var F = window.SMFram, k = JSON.stringify(vels(ctx, st));
      if (sp && F && erDidot(ctx, st)) skraDidot(F);
      if (!sp || !skoridGerd(st.gerd) || p.skraMaelt[k] === true || !F || !F.bua) return sp;
      return Promise.resolve(F.bua(sp, { tima: 2000 })).then(function (r) {
        var Ath = r && r.svg ? H().athugaSkra(r.svg, U) : null;
        p.skraMaelt[k] = Ath ? !!Ath.ok : true;
        if (Ath && !Ath.ok) { p.skraFall = k; if (window.console) console.warn('sm-vs-herbergi: skur\u00f0arskr\u00e1in st\u00f3\u00f0st ekki m\u00e6lingu', k); return { json: JSON.parse(F.json(sp)) }; }
        return sp;
      }, function () { return sp; });
    },
    forhlada: function (s, ctx) {
      var F = window.SMFram, d = !!(ctx && ctx.hb && erDidot(ctx, ctx.hb));
      if (F && F.forhlada) { try { if (d) skraDidot(F); F.forhlada(d ? ['rounded-elegance-open'].concat(DIDOT_IDS) : ['rounded-elegance-open']); } catch (e) {} }
    },
    utlit: {
      teikna: function (s2, ctx, o) {
        if (!H() || !P(ctx).leturKlar) return null;
        var r = flisS(ctx, s2, o);
        if (erDidot(ctx, r) && !P(ctx).didotKlar) return null;
        if (o.lykill === 'staerd') return { svg: smaFlis(staerdSvg(ctx, r, o.gildi, o)) };
        var svg = smaFlis(svgAf(ctx, r, { anAthugunar: true, smamynd: true, bil: 4, id: o.id + 'h' }));
        return svg ? { svg: svg } : null;
      },
      lykill: function (s2, ctx, o) { return flisLykill(ctx, s2, o); }
    },
    /* for tests and the workshop app: the pure parts */
    _innri: { linur: linur, vels: vels, passar: passar, staerdirIBodi: staerdirIBodi, undirIBodi: undirIBodi, normalisera: normalisera, athugaS: athugaS, eiginleikar: eiginleikar, stadaAf: stadaAf, HOTEL_MIN: HOTEL_MIN, HOTEL_MIN2: HOTEL_MIN2, hotelHlutfall: hotelHlutfall }
  };
  if (window.SMVelSida) window.SMVelSida.skra('herbergi', A);
  else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['herbergi', A]);
})();
